import { DataObject } from './data-object.model';

export class Measurement extends DataObject {

    RESOURCETYPE: string;
    STATUS: string;
    CODE: {
        CODING: [
            {
                SYSTEM: string,
                CODE: string,
                DISPLAY: string
            }
        ],
        TEXT: string;
    };
    SUBJECT: {
        REFERENCE: string
    };
    VALUEQUANTITY: {
        VALUE: string,
        UNIT: string,
        CODE: string
    };


    // constructor(obj?: any) {
    //     if (obj) {
    //         // this.measurement = obj;
    //         this.STATUS = obj.STATUS;
    //         this.CODE = obj.CODE;
    //         this.SUBJECT = obj.SUBJECT;
    //         this.VALUEQUANTITY = obj.VALUEQUANTITY;
    //     } else {
    //         this.RESOURCETYPE = 'Observation';
    //         this.STATUS = 'final';
    //         this.CODE = {
    //             'CODING': [
    //                 {
    //                     'SYSTEM': 'http://loinc.org',
    //                     'CODE': '89260-4',
    //                     'DISPLAY': 'Area of wound'
    //                 }
    //             ],
    //             'TEXT': 'Area of wound'
    //         };
    //         this.SUBJECT = {
    //             'REFERENCE': 'Patient/1000000000'
    //         };
    //         this.VALUEQUANTITY = {
    //             'VALUE': '020',
    //             'UNIT': '%',
    //             'CODE': '[%]'
    //         };
    //     }
    // }

    public setPatientId(id: any) {
        this.SUBJECT.REFERENCE = 'Patient/' + String(id);
    }

    public setValue(value: string) {
        this.VALUEQUANTITY.VALUE = value;
    }

    fromObject(obj: any): Measurement {
        return null;
    }

    toJSON(): any {
        return JSON.stringify(this);
    }
}
